module.exports = __webpack_public_path__ + "static/media/promo.b9f37ece.png";